import React from 'react';
import './Header.css';
import MenuIcon from '../../img/menu.svg';

import Logo from '../headerLogo/Logo'
import Menu from "../menu/Menu";
import Button from '../roundedBtn/Button'

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuState : undefined,
        }
    }

    toOpenMenu = (e) => {
        let img1 = e.target.closest('button').children[0];
        console.log(img1);
        if (this.state.menuState === false) {
            this.setState({menuState : true});
        } else if (this.state.menuState === true) {
            this.setState({menuState : false});
        } else {
            img1.classList.add('buttonAnimate');
            this.setState({menuState : true});
        }

    };
    render() {
        return (
            <div className="header">
                <div className="container">
                    <div className="row align-items-center justify-content-end">
                        <Logo></Logo>
                        <Button text={'Інші'} link={'http://tsiko.pp.ua'}></Button>
                        <button onClick={this.toOpenMenu} className="col-xl-1 col-lg-1 col-md-2 col-sm-2 menuButton col-2">
                            <img src={MenuIcon}
                                 alt="MenuToggle"
                                 title="MenuToggle"/>
                        </button>
                        <Menu menuState={this.state.menuState}></Menu>
                    </div>
                </div>
            </div>
        )
    }
}

export default Header;